module.exports = __webpack_public_path__ + "static/img/cont20.f6b55af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont20.jpg
// module id = D3RH
// module chunks = 0